import { render, staticRenderFns } from "./Searchpage.vue?vue&type=template&id=2528ae8c&scoped=true&"
import script from "./Searchpage.vue?vue&type=script&lang=js&"
export * from "./Searchpage.vue?vue&type=script&lang=js&"
import style0 from "./Searchpage.vue?vue&type=style&index=0&id=2528ae8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528ae8c",
  null
  
)

export default component.exports